import Vue from 'vue'
import Vuex from 'vuex'
import user from './module/user'
import requirement from './module/requirement'
import getters from './getters'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    user, requirement
  },
  getters
})
